(function(){
'use strict';
var API='https://club-laf.onrender.com',MAX=5;
function e(v){return String(v==null?'':v).replace(/[&<>"']/g,function(c){return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#039;'}[c]})}
function q(s,r){return (r||document).querySelector(s)}
function qa(s,r){return Array.prototype.slice.call((r||document).querySelectorAll(s))}
function ph(){var m=(location.pathname||'').match(/^\/products\/([^\/?#]+)/i);return m?decodeURIComponent(m[1]):''}
function all(){return /^\/pages\/les-avis-de-nos-clients\/?$/i.test(location.pathname||'')}
function tok(){return new URLSearchParams(location.search).get('review_token')||''}
function st(n){n=Number(n)||0;return '<span class="lafn-stars" aria-label="'+n+' sur 5">'+[1,2,3,4,5].map(function(i){return i<=n?'★':'☆'}).join('')+'</span>'}
function dt(v){if(!v)return '';var d=new Date(v);if(isNaN(d.getTime()))return '';return new Intl.DateTimeFormat('fr-FR',{day:'2-digit',month:'2-digit',year:'numeric'}).format(d)}
async function api(path,opt){var r=await fetch(API+path,Object.assign({headers:{Accept:'application/json'}},opt||{}));var d=await r.json().catch(function(){return {}});if(!r.ok)throw Object.assign(new Error(d.status||('HTTP_'+r.status)),{data:d,status:r.status});return d}
function root(){
  var existing=q('#laf-native-reviews');if(existing)return existing;
  var r=document.createElement('section');r.id='laf-native-reviews';r.className='lafn';
  if(all()){
    var allSlot=q('#vstar-all-reviews');
    if(allSlot){allSlot.replaceChildren(r);return r}
  }
  var intro=q('[data-laf-reviews-anchor]');
  if(intro&&intro.parentNode){intro.parentNode.insertBefore(r,intro.nextSibling);return r}
  var old=q('#vstar-reviews')||q('.trustoo-reviews-wrapper');
  if(old&&old.parentNode){old.parentNode.insertBefore(r,old);old.style.display='none';return r}
  (q('#MainContent')||q('main')||document.body).appendChild(r);return r
}
function cards(list){
 if(!list||!list.length)return '<div class="lafn-empty">Aucun avis pour le moment.</div>';
 return '<div class="lafn-grid">'+list.map(function(x){
  var media=(x.laf_review_media||[]).filter(function(m){return m&&m.status==='ready'&&m.public_url});
  return '<article class="lafn-card"><div class="lafn-top"><strong>'+e(x.author_name||'Client LAF')+'</strong>'+(x.verified_purchase?'<span class="lafn-badge">✓ Achat vérifié</span>':'')+'</div>'+st(x.rating)+(x.commented_at?'<div class="lafn-date">'+e(dt(x.commented_at))+'</div>':'')+(x.item_type?'<div class="lafn-variant">VARIANTE ACHETÉE · '+e(x.item_type)+'</div>':'')+(x.title?'<h4>'+e(x.title)+'</h4>':'')+'<p>'+e(x.content||'').replace(/\n/g,'<br>')+'</p>'+(media.length?'<div class="lafn-photos">'+media.map(function(m,i){return '<button type="button" class="lafn-photo-btn" data-lafn-photo="'+e(m.public_url)+'" data-lafn-index="'+i+'" aria-label="Agrandir la photo"><img src="'+e(m.public_url)+'" alt="Photo client" loading="lazy"></button>'}).join('')+'</div>':'')+(x.reply?'<div class="lafn-reply"><strong>Réponse LAF</strong><p>'+e(x.reply)+'</p></div>':'')+'</article>'
 }).join('')+'</div>'
}
function button(){return '<button type="button" class="lafn-btn" data-lafn-write>Écrire un commentaire</button>'}
function summary(s){return '<div class="lafn-summary"><strong>'+String(s.average||0).replace('.',',')+'/5</strong>'+st(Math.round(s.average||0))+'<span>'+Number(s.count||0)+' avis</span></div>'}
async function product(r,h){
 r.classList.add('lafn--product');
 r.innerHTML='<div class="lafn-wrap lafn-product-body"><div class="lafn-product-toolbar"><div><div class="lafn-product-toolbar__kicker">AVIS CLIENTS</div><h2>Derniers avis</h2></div>'+button()+'</div><div data-lafn-list><div class="lafn-empty">Chargement des avis…</div></div></div>';
 bind(r,{type:'product',handle:h});
 try {
  var d=await api('/api/reviews?type=product&product_handle='+encodeURIComponent(h)+'&limit=24');
  r.__lafCurrentReviews=d.reviews||[];
  q('[data-lafn-list]',r).innerHTML=cards(r.__lafCurrentReviews);
  bindPhotos(r);
 } catch(err) {
  q('[data-lafn-list]',r).innerHTML='<div class="lafn-empty">Les anciens avis sont temporairement indisponibles. Vous pouvez toujours publier le vôtre.</div>';
  console.error('[LAF Product Reviews load]',err);
 }
}
async function global(r){
 r.classList.add('lafn--global');
 r.innerHTML='<div class="lafn-global-hero"><div class="lafn-global-hero__inner"><div class="lafn-global-hero__copy"><div class="lafn-global-kicker">AVIS CLIENTS · COMMUNAUTÉ LAF</div><h1>ILS EN PARLENT<br><span>MIEUX QUE NOUS.</span></h1><p>Des retours laissés par celles et ceux qui portent, testent et utilisent réellement nos produits.</p></div><div class="lafn-global-hero__side"><div class="lafn-global-summary" data-lafn-summary><span class="lafn-global-summary__label">NOTE MOYENNE</span><strong>—</strong><span>Chargement…</span></div>'+button()+'</div></div></div><div class="lafn-global-body"><div class="lafn-global-body__inner"><div class="lafn-global-toolbar"><div><div class="lafn-global-toolbar__kicker">TOUS LES RETOURS</div><h2>Choisissez ce que vous voulez consulter.</h2></div><div class="lafn-tabs"><button class="active" data-tab="product">AVIS PRODUITS</button><button data-tab="store">AVIS BOUTIQUE</button></div></div><div data-lafn-list><div class="lafn-empty">Chargement des avis…</div></div><nav class="lafn-pagination" data-lafn-pagination aria-label="Pagination des avis"></nav></div></div>';
 var activeType='product',activePage=1,LIMIT=24;

 function pager(total,page){
   var pages=Math.max(1,Math.ceil(Number(total||0)/LIMIT));
   if(pages<=1)return '';
   var out='<button type="button" class="lafn-page lafn-page--nav" data-page="'+(page-1)+'"'+(page<=1?' disabled':'')+'>‹ Précédent</button>';
   var nums=[];
   if(pages<=12){
     for(var i=1;i<=pages;i++)nums.push(i);
   }else{
     nums=[1];
     var from=Math.max(2,page-2),to=Math.min(pages-1,page+2);
     if(from>2)nums.push('…');
     for(var j=from;j<=to;j++)nums.push(j);
     if(to<pages-1)nums.push('…');
     nums.push(pages);
   }
   out+=nums.map(function(n){
     if(n==='…')return '<span class="lafn-page-dots" aria-hidden="true">…</span>';
     return '<button type="button" class="lafn-page'+(n===page?' active':'')+'" data-page="'+n+'" aria-label="Page '+n+'"'+(n===page?' aria-current="page"':'')+'>'+n+'</button>';
   }).join('');
   out+='<button type="button" class="lafn-page lafn-page--nav" data-page="'+(page+1)+'"'+(page>=pages?' disabled':'')+'>Suivant ›</button>';
   return out;
 }

 async function load(t,p,scroll){
   activeType=t;
   activePage=Math.max(1,Number(p)||1);
   qa('[data-tab]',r).forEach(function(b){b.classList.toggle('active',b.getAttribute('data-tab')===t)});
   var list=q('[data-lafn-list]',r),nav=q('[data-lafn-pagination]',r);
   list.innerHTML='<div class="lafn-empty">Chargement des avis…</div>';
   nav.innerHTML='';
   var d=await api('/api/reviews?type='+t+'&limit='+LIMIT+'&page='+activePage);
   var s=d.summary||{},pages=Math.max(1,Math.ceil(Number(s.count||0)/LIMIT));
   if(activePage>pages){activePage=pages;return load(t,activePage,scroll)}
   q('[data-lafn-summary]',r).innerHTML='<span class="lafn-global-summary__label">'+(t==='product'?'NOTE DES PRODUITS':'NOTE DE LA BOUTIQUE')+'</span><div class="lafn-global-summary__score"><strong>'+String(s.average||0).replace('.',',')+'</strong><span>/5</span></div>'+st(Math.round(s.average||0))+'<span class="lafn-global-summary__count">'+Number(s.count||0)+' avis publiés</span>';
   r.__lafCurrentReviews=d.reviews||[];
   list.innerHTML=cards(r.__lafCurrentReviews);
   bindPhotos(r);
   nav.innerHTML=pager(s.count,activePage);
   qa('[data-page]',nav).forEach(function(b){
     b.addEventListener('click',async function(){
       if(b.disabled)return;
       await load(activeType,Number(b.getAttribute('data-page')),true);
     })
   });
   if(scroll){
     var toolbar=q('.lafn-global-toolbar',r);
     if(toolbar)toolbar.scrollIntoView({behavior:'smooth',block:'start'});
   }
 }

 qa('[data-tab]',r).forEach(function(b){b.addEventListener('click',function(){load(b.getAttribute('data-tab'),1,false)})});
 bind(r,{type:'store'});await load('product',1,false)
}
function files(fs){return Promise.all(fs.slice(0,MAX).map(function(f){return new Promise(function(ok,no){if(f.size>3*1024*1024)return no(new Error('PHOTO_TOO_LARGE'));var rd=new FileReader;rd.onload=function(){ok({name:f.name,type:f.type,data:rd.result})};rd.onerror=no;rd.readAsDataURL(f)})}))}
function modal(ctx,req){
 if(ph())ctx={type:'product',handle:ph()};
 var ps=req&&req.products||[],pick='';
 if(ctx.type==='product')pick='<input type="hidden" name="product_handle" value="'+e(ctx.handle||'')+'">';
 else if(ps.length)pick='<label>Produit acheté<select name="product_handle" required><option value="">Choisir un produit</option>'+ps.map(function(p){return '<option value="'+e(p.handle)+'">'+e(p.title+(p.variant_title?' · '+p.variant_title:''))+'</option>'}).join('')+'</select></label>';
 return '<div class="lafn-modal" data-lafn-modal role="dialog" aria-modal="true" aria-label="Écrire un avis LAF"><div class="lafn-back" data-close></div><div class="lafn-box"><button type="button" class="lafn-close" data-close>×</button><div class="lafn-kicker">CLUB LAF</div><h3>ÉCRIRE UN COMMENTAIRE</h3><p class="lafn-help">Si nous retrouvons une commande payée dans les 30 derniers jours, votre avis sera marqué Achat vérifié. Vous gagnez 15 points CLUB LAF, ou 30 points avec une photo, une seule fois par commande.</p><form data-form>'+pick+'<label>Votre note<select name="rating" required><option value="">Choisir</option><option value="5">5 ★</option><option value="4">4 ★</option><option value="3">3 ★</option><option value="2">2 ★</option><option value="1">1 ★</option></select></label><label>Nom<input name="author_name" required maxlength="100" value="'+e(req&&req.author_name||'')+'"></label><label>E-mail<input type="email" name="author_email" required maxlength="320" value="'+e(req&&req.author_email||'')+'"></label><label>Votre commentaire<textarea name="content" required maxlength="5000" rows="5"></textarea></label><label>Photos <span>(facultatif · 5 maximum · 3 Mo chacune)</span><input type="file" name="photos" accept="image/jpeg,image/png,image/webp,image/gif" multiple></label><button class="lafn-btn" data-submit type="submit">PUBLIER MON AVIS</button><div class="lafn-msg" data-msg role="status" aria-live="polite"></div></form></div></div>'
}
async function open(ctx){
  var pageHandle=ph();
  if(pageHandle)ctx={type:'product',handle:pageHandle};
  // Shopify uses data-modal on unrelated elements (e.g. modal-opener).
  // Never select these instead of the LAF review dialog.
  if(q('[data-lafn-modal]'))return;
  var req=null,t=tok();
  if(t){try{req=await api('/api/reviews/request?token='+encodeURIComponent(t))}catch(err){console.warn('[LAF Reviews request token]',err)}}
  document.body.insertAdjacentHTML('beforeend',modal(ctx,req));
  var m=q('[data-lafn-modal]');
  if(!m)return;
  var f=q('[data-form]',m),msg=q('[data-msg]',m),submitButton=q('[data-submit]',m);
  if(!f||!msg||!submitButton){console.error('[LAF Reviews] Missing form controls');return}
  var sending=false,saved=false;
  function close(){
    if(sending)return;
    m.remove();
    if(saved)window.location.reload();
  }
  qa('[data-close]',m).forEach(function(x){
    x.addEventListener('click',function(ev){ev.preventDefault();ev.stopPropagation();close()});
  });
  async function submitReview(ev){
    if(ev){
      ev.preventDefault();
      ev.stopPropagation();
      if(typeof ev.stopImmediatePropagation==='function')ev.stopImmediatePropagation();
    }
    if(sending||saved)return;
    if(!f.reportValidity())return;
    sending=true;
    submitButton.disabled=true;
    submitButton.textContent='ENVOI EN COURS…';
    msg.textContent='Vérification et enregistrement de votre avis…';
    try{
      var fd=new FormData(f);
      var handle=(ph()||String(fd.get('product_handle')||'')||String(ctx.handle||'')).trim().toLowerCase();
      if(ctx.type==='product'&&!handle)throw new Error('PRODUCT_HANDLE_MISSING');
      var type=handle?'product':'store';
      if(type==='product'&&!/^[a-z0-9][a-z0-9-]*$/.test(handle))throw new Error('PRODUCT_HANDLE_MISSING');
      var photoInput=f.elements.namedItem('photos');
      var photos=await files(Array.from(photoInput&&photoInput.files?photoInput.files:[]));
      var payload={
        review_type:type,
        product_handle:type==='product'?handle:undefined,
        rating:Number(fd.get('rating')),
        author_name:String(fd.get('author_name')||''),
        author_email:String(fd.get('author_email')||''),
        content:String(fd.get('content')||''),
        review_token:t||undefined,
        photos:photos
      };
      var d=await api('/api/reviews/submit',{
        method:'POST',
        headers:{'Content-Type':'application/json',Accept:'application/json'},
        body:JSON.stringify(payload)
      });
      if(d.ok!==true||!d.review_id||d.status!=='published'||(d.review_type&&d.review_type!==type)||(type==='product'&&d.product_handle&&d.product_handle!==handle)){
        throw new Error('REVIEW_NOT_SAVED');
      }
      saved=true;
      var rw=d.reward||{};
      var statusText=d.published===false?'Avis enregistré, en attente de publication.':'Avis publié avec succès.';
      var extra=d.verified_purchase?' Achat vérifié.':'';
      if(rw.status==='awarded'&&Number(rw.points)>0)extra+=' +'+Number(rw.points)+' points CLUB LAF crédités.';
      msg.textContent=statusText+extra+' Vous pouvez fermer cette fenêtre pour voir les avis actualisés.';
      submitButton.textContent='AVIS ENREGISTRÉ';
    }catch(err){
      console.error('[LAF Reviews submit]',err);
      var status=err&&err.data&&err.data.status;
      msg.textContent=status==='verified_review_already_exists'
        ?'Un avis vérifié a déjà été enregistré pour cette commande.'
        :status==='rate_limited'
        ?'Trop de tentatives. Réessayez ultérieurement.'
        :err.message==='PHOTO_TOO_LARGE'
        ?'Une photo dépasse 3 Mo : réduisez sa taille et réessayez.'
        :err.message==='PRODUCT_HANDLE_MISSING'
        ?'Le produit n’a pas pu être identifié. Rechargez cette page.'
        :'Échec de l’enregistrement : votre avis n’a pas été publié. Réessayez sans fermer cette fenêtre.';
      submitButton.disabled=false;
      submitButton.textContent='RÉESSAYER L’ENVOI';
    }finally{
      sending=false;
    }
  }
  // Explicit non-submitting button prevents a native form navigation if
  // another Shopify script interferes with the submit handler.
  submitButton.type='button';
  submitButton.addEventListener('click',submitReview,true);
  // Also handle Enter-key submission; never let the browser navigate away.
  f.addEventListener('submit',submitReview,true);
}
function photoViewer(review,media,start){
 var index=Math.max(0,Math.min(Number(start)||0,media.length-1));
 function photoSrc(){return media[index]&&media[index].public_url?media[index].public_url:''}
 var html='<div class="lafn-viewer" data-lafn-viewer><div class="lafn-viewer-back" data-lafn-viewer-close></div><div class="lafn-viewer-box" role="dialog" aria-modal="true" aria-label="Photo d’avis client"><button type="button" class="lafn-viewer-close" data-lafn-viewer-close aria-label="Fermer">×</button><div class="lafn-viewer-media"><button type="button" class="lafn-viewer-nav lafn-viewer-prev" data-lafn-prev aria-label="Photo précédente">‹</button><img data-lafn-viewer-img src="'+e(photoSrc())+'" alt="Photo client agrandie"><button type="button" class="lafn-viewer-nav lafn-viewer-next" data-lafn-next aria-label="Photo suivante">›</button></div><div class="lafn-viewer-info"><div class="lafn-viewer-author"><strong>'+e(review.author_name||'Client LAF')+'</strong>'+(review.verified_purchase?'<span class="lafn-badge">✓ Achat vérifié</span>':'')+'</div><div class="lafn-viewer-stars">'+st(review.rating)+'</div>'+(review.commented_at?'<div class="lafn-viewer-date">'+e(dt(review.commented_at))+'</div>':'')+(review.item_type?'<div class="lafn-variant">VARIANTE ACHETÉE · '+e(review.item_type)+'</div>':'')+(review.title?'<h3>'+e(review.title)+'</h3>':'')+'<p>'+e(review.content||'').replace(/\n/g,'<br>')+'</p>'+(review.reply?'<div class="lafn-reply"><strong>Réponse LAF</strong><p>'+e(review.reply)+'</p></div>':'')+'<div class="lafn-viewer-count" data-lafn-viewer-count></div></div></div></div>';
 document.body.insertAdjacentHTML('beforeend',html);
 var v=q('[data-lafn-viewer]'),img=q('[data-lafn-viewer-img]',v),count=q('[data-lafn-viewer-count]',v),prev=q('[data-lafn-prev]',v),next=q('[data-lafn-next]',v);
 var oldOverflow=document.documentElement.style.overflow;document.documentElement.style.overflow='hidden';
 function draw(){img.src=photoSrc();count.textContent=media.length>1?(index+1)+' / '+media.length:'';prev.hidden=media.length<2;next.hidden=media.length<2}
 function close(){document.documentElement.style.overflow=oldOverflow;document.removeEventListener('keydown',keys);v.remove()}
 function keys(ev){if(ev.key==='Escape')close();if(ev.key==='ArrowLeft'&&media.length>1){index=(index-1+media.length)%media.length;draw()}if(ev.key==='ArrowRight'&&media.length>1){index=(index+1)%media.length;draw()}}
 qa('[data-lafn-viewer-close]',v).forEach(function(x){x.onclick=close});
 prev.onclick=function(){index=(index-1+media.length)%media.length;draw()};
 next.onclick=function(){index=(index+1)%media.length;draw()};
 document.addEventListener('keydown',keys);draw()
}
function bindPhotos(r){
 qa('.lafn-card',r).forEach(function(card){
   var buttons=qa('[data-lafn-photo]',card);
   if(!buttons.length)return;
   buttons.forEach(function(b){
     b.onclick=function(){
       var reviewCard=card;
       var allCards=qa('.lafn-card',r);
       var cardIndex=allCards.indexOf(reviewCard);
       var list=r.__lafCurrentReviews||[];
       var review=list[cardIndex];
       if(!review)return;
       var media=(review.laf_review_media||[]).filter(function(m){return m&&m.status==='ready'&&m.public_url});
       photoViewer(review,media,Number(b.getAttribute('data-lafn-index'))||0)
     }
   })
 })
}
function bind(r,c){qa('[data-lafn-write]',r).forEach(function(b){b.onclick=function(){open(c)}})}
async function boot(){var h=ph();if(!h&&!all())return;var r=root();try{if(h)await product(r,h);else await global(r);if(tok())setTimeout(function(){if(!q('[data-modal]'))open(h?{type:'product',handle:h}:{type:'store'})},250)}catch(err){r.innerHTML='<div class="lafn-wrap"><div class="lafn-empty">Les avis sont momentanément indisponibles.</div></div>';console.error('[LAF Native Reviews]',err)}}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot,{once:true});else boot()
})();